export default "__VITE_ASSET__C5nt4u3x__"